<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Đổi mật khẩu tài khoản</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="12">
          <el-form label-position="left" :model="modelData" ref="createModel" label-width="155px" @submit.native.prevent>
            <el-form-item prop="old_password" label="Mật khẩu cũ" class="form-item"
              :rules="[
                { required: true, message: 'Vui lòng nhập mật khẩu cũ', trigger: 'blur' }
              ]">
              <el-input v-model="modelData.old_password" class="input-seach"></el-input>
            </el-form-item>
            <el-form-item prop="password" label="Mật khẩu mới" class="form-item"
              :rules="[
                { required: true, message: 'Vui lòng nhập mật khẩu mới', trigger: 'blur' }
              ]">
              <el-input type="password" v-model="modelData.password" class="input-seach"></el-input>
            </el-form-item>
            <el-form-item prop="password_confirmation" label="Mật khẩu xác nhận" class="form-item"
              :rules="[
                { required: true, message: 'Vui lòng nhập mật khẩu xác nhận', trigger: 'blur' }
              ]">
              <el-input type="password" v-model="modelData.password_confirmation" class="input-seach"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="warning"
                  size="small"
                  @click="submitForm('createModel')"
                  native-type="submit">Cập nhật</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
              </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'AccountResetPass',
  data () {
    return {
      canSubmit: true,
      modelData: {
        old_password: '',
        password: '',
        password_confirmation: ''
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'account-show', text: 'Tài khoản' },
        { name: 'account-reset-pass', text: 'Đổi mật khẩu' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'home-index'})
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    updateModel () {
      this.canSubmit = false
      axios.post('account/change-password', this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật mật khẩu thành công',
              type: 'success'
            })
            this.$router.push({name: 'account-show'})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/account/ResetPass.vue